<template>
  <div
    v-click-outside="closeFilter"
    v-if="$props.visible"
    class="lessons-filter"
  >
    <div class="row">
      <ClassesDropdown
        class="half-third"
        label="Класс"
        @setItem="val => setItem({'study_year': val})"
      />
      <RegistrationDropdown
        class="half-third"
        label="Место регистрации"
        @setItem="val => setItem({'register_by_service': val})"
      />
      <StatusDropdown
        class="half-third"
        label="Статус заявки на поступление"
        @setItem="val => setItem({'admission_status_id': val})"
      />
    </div>
    <div class="row">
      <GroupsDropdown
        class="half-second"
        label="Группа"
        @setItem="val => setItem({'groups_ids': val})"
      />
      <CoursesDropdown
        class="half-third"
        label="Курсы(открытые)"
        @setItem="val => setItem({'courses_ids': val})"
      />
      <div class="labels-input-relative-align">
        <div class="buttons">
          <div class="btn">
            <BaseButton
              small
              @click="applyFilters"
            >
              Применить
            </BaseButton>
          </div>
          <div class="btn">
            <BaseButton
              class="borderless"
              small
              border-without-bg
              @click="resetFilters"
            >
              Сбросить фильтры
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <Icon
      type="close"
      class="close-icon"
      size="10"
      @click="toggleVisibility(false)"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Icon from '@/ui/icon/Icon.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import RegistrationDropdown from '@/pages/users/students/list/parts/registration-dropdown/RegistrationDropdown.vue'
import StatusDropdown from '@/pages/users/students/list/parts/statuses-dropdown/StatusDropdown.vue'
import ClassesDropdown from '@/pages/users/students/list/parts/classes-dropdown/ClassesDropdown.vue'
import GroupsDropdown from '@/pages/users/students/list/parts/groups-dropdown/GroupsDropdown.vue'
import CoursesDropdown from '@/pages/users/students/list/parts/courses-dropdown/CoursesDropdown.vue'
import ClickOutside from '@/features/directives/click-outside.ts'
import { toggleVisibility } from '@/pages/users/students/list/model/tooltip-filter.model'

Vue.directive('click-outside', ClickOutside)

export default Vue.extend({
  name: 'ToolTipFilter',
  components: {
    Icon,
    ClassesDropdown,
    RegistrationDropdown,
    StatusDropdown,
    GroupsDropdown,
    BaseButton,
    CoursesDropdown,
  },
  props: {
    visible: { type: Boolean, required: true, default: false },
  },
  methods: {
    toggleVisibility,
    closeFilter(event) {
      // check for general filter icon
      if (!event.target.closest('#filter-icon')) {
        toggleVisibility(false)
      }
    },
    setItem(filter) {
      this.$emit('changeFilter', filter)
    },
    applyFilters() {
      this.$emit('setFilter')
      toggleVisibility(false)
    },
    resetFilters() {
      this.$emit('resetFilter') // general filter
    },
  },
})
</script>

<style scoped>
.lessons-filter {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  padding: 30px 20px;
  background-color: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  .row {
    &:not(:first-child) {
      margin-top: 20px;
    }
  }
  .close-icon {
    position: absolute;
    top: 21px;
    right: 21px;
  }
}

.row {
  display: flex;
  justify-content: space-between;
}

.half-second {
  width: 100%;
  margin-right: 30px;
}

.half-third {
  width: calc(100% / 3 - 20px);
  flex-shrink: 0;
}

.labels-input-relative-align {
  width: 100%;
  display: flex;
  align-self: flex-end;
  height: 46px;

  .buttons {
    display: flex;
    align-items: center;
    margin-left: auto;

    .btn:first-child {
      margin-right: 38px;
    }
  }
}

.btn {
  width: max-content;
}

.borderless {
  border-color: transparent !important;
  @mixin underline-text;
}

.close-icon {
  cursor: pointer;
  fill: var(--c-grey-3);
}
</style>
